import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';
import { NavigateFunction } from "react-router-dom";

export interface LoginPageState {
    email: string;
    password: string;
}

const initialState: LoginPageState = {
    email: "",
    password: "",
}

export const LoginPageSlice = createSlice({
    name: 'loginPage',
    initialState,
    reducers: {
        onEmailChanged: (state, action: PayloadAction<string>) => {
            state.email = action.payload;
        },
        onPasswordChanged: (state, action: PayloadAction<string>) => {
            state.password = action.payload;
        },
    }
});

export const loginAsync = createAsyncThunk<void, NavigateFunction, { state: RootState }>(
    'loginPage/loginAsync',
    async (navigate, { dispatch, getState, rejectWithValue }) => {
        let appState = getState();
        const state = appState.loginPage;

        if (state.email != "brennankapp@gmail.com" && state.email != "christian.strydom@gmail.com" && state.email != "kevin.campher@voucherprotect.com") {
            return;
        }

        var authenticationResult = await signInWithEmailAndPassword(auth, state.email, state.password);

        if (authenticationResult.user == null) {
            return;
        }

        navigate("/AdministratorOptionsPage");
        return;
    }
);

export const { onEmailChanged, onPasswordChanged } = LoginPageSlice.actions;

export const selectState = (state: RootState) => state.loginPage;

export default LoginPageSlice.reducer;